import axios from 'axios';

export const equipmentStoreReplaceApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipment-store-replace`,
    headers: {
        'Content-Type': 'application/json'
    }
})